export default function Hero() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-[64px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              每日更新 · 高清不缓冲
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              色影视 · <span className="text-primary-600">高清免费影视</span>在线平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              超清画质，流畅播放，无需付费注册
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              色影视汇聚海量高清免费电影、高清免费电视剧和高清免费综艺节目，致力于为每一位影视爱好者提供超清画质、流畅不缓冲的观影体验。打开即看，无需注册付费，每日更新最新热门影视剧集。无论你是追剧狂人还是电影发烧友，这里都是你的专属影视乐园。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600">50,000+</span>
                <span className="text-xs md:text-sm text-foreground-500">影视资源</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</span>
                <span className="text-xs md:text-sm text-foreground-500">50+部</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600">全免费</span>
                <span className="text-xs md:text-sm text-foreground-500">无需注册</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => { e.preventDefault(); scrollToSection('#media'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); scrollToSection('#features'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm border border-background-300/60"
              >
                <i className="ri-information-line text-lg"></i>
                了解平台
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/5 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20movie%20collage%20with%20warm%20golden%20and%20amber%20lighting%20film%20strip%20and%20projector%20elements%20elegant%20dark%20background%20with%20soft%20glow%20professional%20editorial%20design%20rich%20atmospheric%20composition%20movie%20poster%20style%20abstract%20cinematic%20art&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="色影视 - 高清免费影视在线观影平台"
                className="relative w-full h-auto rounded-2xl object-cover shadow-sm"
                width="800"
                height="600"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}